export default {
  leoChat: {
    chat_1475da: "企业登录",
    chat_16f606: "整数；单位依设备/约定",
    chat_17dfdc: "我的偏好",
    chat_22f4eb: "用量与计费",
    chat_27e8b6: "标签（来自记忆偏好）",
    chat_29f404: "调理机配方",
    chat_30_can_4ab820: "近 30 日 CAN 解码帧",
    chat_30_can_8fe750: "近 30 日 CAN 计量合计",
    chat_30_e47539: "近 30 日已入账扣款",
    chat_30_token_16fa23: "近 30 日 Token",
    chat_33613d: "对话",
    chat_40d6e4: "以访客身份继续（产品与公开咨询）",
    chat_43631f: "停止聆听",
    chat_4845c6: "处理中…",
    chat_553891: "填入并对齐设备",
    chat_5cd727: "返回对话",
    chat_62e9d1: "选择模式",
    chat_6888c5: "保存",
    chat_6adada: "控制台",
    chat_6d1197: "服务条款与隐私政策",
    chat_7106a7: "机台商品",
    chat_71c576: "请输入密码",
    chat_755be2: "出品建档",
    chat_7847b8: "发送",
    chat_7e76c4: "尚未建立计费账户；保存后将以所选模式开始计量。",
    chat_805f8b: "使用此内容",
    chat_85406a: "跳过朗读",
    chat_965a50: "店铺管理员",
    chat_9b2c38: "输入消息",
    chat_9cbbd1: "最近一次识别",
    chat_a84cf9: "留空＝全局偏好；指定则为该机专属",
    chat_ab185d: "填入输入框",
    chat_abd535: "注册会员",
    chat_api_a76f41: "（订阅方案请由运营或 API 建立）",
    chat_app_c884f6: "若其他 App 已复制链接或机码，直接粘贴即可。",
    chat_b347b6: "目前计费设置",
    chat_b6d41c: "复制指令",
    chat_cta_title_7535dd: "cta.title",
    chat_curve_soft_7e9ea0: "例如 curve_soft",
    chat_d2de5e: "注册完成，请以会员身份重新登录后继续。",
    chat_d5e285: "我已阅读并同意",
    chat_d5edfc: "复制全文",
    chat_da4d71: "会员登录",
    chat_docs_leo_brain_ident_64cb16: "docs/leo_brain/IDENTITY_PROTOCOL.md",
    chat_docs_leo_brain_leo_p_6f7d10: "docs/leo_brain/LEO_PERSONALIZATION_SCENARIO.md",
    chat_e31e3a: "后台完整登录页",
    chat_e6a549: "关闭",
    chat_ea544c: "请输入账号",
    chat_ef5cb: "重新加载",
    chat_email_leo_fda298: "Email + 密码；登录后回到 Leo 对话并依步骤完成开通。",
    chat_eur_394b9b: "EUR",
    chat_f98d0d: "保存设置",
    chat_fe497b: "请以会员账号登录；店铺管理员请用「企业后台」分页。登录后依提示完成家用或商用设置。",
    chat_hintauth_a22705: "hintAuth",
    chat_https_localhost_qr_e4c72c: "需相机权限；建议 HTTPS 或 localhost。对准设备或产品上的 QR/条码。",
    chat_leo_323396: "Leo 用量与计费",
    chat_leo_99743: "Leo 导览",
    chat_leo_ac1503: "会员登录并进入 Leo",
    chat_leo_e3ca11: "Leo 开通步骤",
    chat_leo_e7dd0: "Leo",
    chat_leo_e9f6cd: "企业登录并进入 Leo",
    chat_loaderror_108d9d: "加载错误",
    chat_name_example_com_cb4900: "name@example.com",
    chat_night_owl_b82e53: "例如 night_owl",
    chat_png_d92bec: "下载 PNG",
    chat_qr_25f92d: "扫描与产品 QR",
    chat_qr_40dfbd: "生成 QR",
    chat_qr_a9ae66: "选取相册截图或照片，离线识别 QR/条码。",
    chat_session_inputplaceho_bbe0d1: "session.inputPlaceholderZh ||",
    chat_sku_qr_png_c9b88c: "将门店配方关键字、网址或 SKU 转成 QR，可下载 PNG 打印贴标。",
    chat_token_7959d6: "累计 Token（全期间）",
    chat_token_can_dbc_28957f: "查看 Token 与车载 CAN/DBC 用量、钱包/账本扣款记录（请以会员登录，或后台账号已完成商用绑定）。",
    chat_user_ace2e8: "后台 User 账号；具备菜单权限者可操作设备与数据中心。",
    chat_voicemictitle_650ed3: "voiceMicTitle",
    chat_voicesiriarialabel_76d873: "voiceSiriAriaLabel",
    chat_wsstatustitle_f6c66f: "wsStatusTitle",
  },
  leoNl: {
      busy: "…",
      close: "Close",
      enable: "要为此语言启用 Leo NL 吗？",
      later: "稍后",
      no: "否",
      subProgress: "生成中…",
      subPrompt: "使用 AI 理解 %1$s 语音指令",
      titleProgress: "正在准备 Leo NL 语言理解…",
      titlePrompt: "要为此语言启用 Leo NL 吗？",
      titleReady: "Leo NL 语言包已就绪",
      yes: "是",
  },
  route: {
    homePage:'首页',
    dataDisplay:'数据展示',
    atlas:'地图',
    journal:'日志',
    details:'详情',
    systemSetting:'系统设置',
    aiTrusteeAdmin: 'AI 托管管理台',
    agentPermissionSteward: 'Agent 權限管家',
    loginAccount:'账号管理',
    merchants:'商户管理',
    devices: "设备管理",
    material: "物料管理",
    deviceConfig: "设备配置",
    channelConfiguration: "通道配置",
    configProfileLibrary: "配置档案库",
    coffeeMachineChannelSlots: "X600H配方中心",
    configBindDispatch: "绑定与下发",
    leoKnowledgeGroup: 'Leo 知识库',
    leoKnowledgeModelFields: '型号知识字段',
    leoKnowledgeEquipmentTypeTypeKey: '设备类型 type_key',
    leoKnowledgeUpload: '知识上传',
    leoKnowledgeIngestBatch: '入库批次（自动创建）',
    leoKnowledgePhase1Ssot: 'Phase1 SSOT 管线',
    leoKnowledgeCapabilityMatrix: '能力矩阵',
    leoKnowledgeOnboarding: '智慧型号引导',
    leoKnowledgeTesterConsole: '测试员主控台',
    leoKnowledgePipelineHub: '管线总览',
    leoKnowledgeFeatureSurface: '功能→API 映射',
    leoKnowledgeProtocolDoc: '协议文档索引',
    leoKnowledgeRemoteTools: '遥控工具目录',
    leoKnowledgeLearning: '学习闭环',
    leoKnowledgeExternalIngest: '外部知识入库',
    leoKnowledgePortalHub: 'Leo 对话与营运',
    leoKnowledgePortalHubDesc: '从此打开 Leo 对话（主入口）与 Biz 营运功能；Console／Portal 仅内部运维。',
    leoKnowledgePortalHubHint: '主权台为气泡式智慧问答版面；门户为精简入口。如需 portalToken／ceoBearer，请在打开后于地址栏补充查询参数。',
    leoKnowledgeUiSurfaceSample: '后台视觉样板（舒适灰底）',
    uiSurfaceSampleLead: '示范「页面浅灰底＋内容白卡」层次，减轻长时间盯全白画面的疲劳；若满意可再抽成全局主题变量推广。',
    uiSurfaceSampleAlert: '此页仅供视觉与版面参考，表单与表格为示意数据，不会调用后端。',
    uiSurfaceSampleKpi_orders: '今日订单（示意）',
    uiSurfaceSampleKpi_online: '在线设备',
    uiSurfaceSampleKpi_alerts: '待处理告警',
    uiSurfaceSampleKpiSub: '样板数字',
    uiSurfaceSampleFilterTitle: '筛选区（白卡）',
    uiSurfaceSampleKeyword: '关键字',
    uiSurfaceSampleKeywordPh: '名称或编号',
    uiSurfaceSampleStatus: '状态',
    uiSurfaceSampleStAll: '全部',
    uiSurfaceSampleStOn: '启用',
    uiSurfaceSampleStOff: '停用',
    uiSurfaceSampleReset: '重置',
    uiSurfaceSampleSelectPh: '请选择',
    uiSurfaceSampleTableTitle: '列表示意（白卡＋表格）',
    uiSurfaceSampleColName: '名称',
    uiSurfaceSampleColRegion: '区域',
    uiSurfaceSampleColStatus: '状态',
    uiSurfaceSampleColUpdated: '更新时间',
    uiSurfaceSampleCompareTitle: '对照：全白区块 vs 分层灰底',
    uiSurfaceSampleCompareOld: '旧感：大面积纯白',
    uiSurfaceSampleCompareOldDesc: '内容与背景同色时，边界较不分明，长时间阅读容易累。',
    uiSurfaceSampleCompareNew: '建议：灰底上的白卡',
    uiSurfaceSampleCompareNewDesc: '主内容仍在白底上维持对比；页面级用浅灰承托，视线有落点。',
    leoPortalHubSovereign: '主权台（全屏）',
    leoPortalHubPortal: '门户',
    leoPortalHubDeviceIntegrationSection: '装置端整合',
    leoPortalHubDeviceIntegrationLink: '对外说明与工具（新标签页）',
    leoPortalHubRuntimeModuleLink: '装置云运行期 AAR（新标签页）',
    leoPortalHubSdkLabSection: 'XRROSS SDK（工程测试）',
    leoPortalHubSdkEngineerLabOpen: '全功能测试台（第一轨＋第二轨，新标签页）',
    leoPortalHubSdkPublicTrack1: '第一轨对外说明',
    leoPortalHubSdkPublicTrack2: '第二轨对外说明',
    leoPortalHubChatSection: '对话入口',
    leoPortalHubPreferences: '我的偏好',
    leoPortalHubLogin: '登录',
    leoPortalHubSectionOps: '运营控制台',
    leoPortalHubSectionOpsDesc: '后台实时对话流、CEO／门户主权窗口，适合大屏验收与值守。',
    leoPortalHubSectionPortal: '行动门户',
    leoPortalHubSectionPortalDesc: '精简入口，便于手机或对外展示。',
    leoPortalHubSectionChat: '智慧对话',
    leoPortalHubSectionChatDesc: 'Leo 智慧对话；下方可调整偏好或登录。',
    leoPortalHubSectionDeviceDesc: '对外说明、运行期模块与整合文档（均在新标签页打开）。',
    leoPortalHubSectionSdkDesc: '工程师用于两轨串接、回归与调试的统一测试台。',
    leoPortalHubCardSovereignDesc: '气泡式智慧问答、Markdown 与 SOP 步骤卡片。',
    leoPortalHubCardPortalDesc: '精简 Leo 门户；必要时在网址加上 portalToken／ceoBearer。',
    leoPortalHubCardLeoDesc: '默认 Leo 对话；一般运营、知识问答与遥控（全球会员同一入口）。',
    leoPortalHubCardPrefDesc: '人设、地区与个性化选项。',
    leoPortalHubCardLoginDesc: '使用后台账号登录后再使用写入／敏感能力。',
    leoPortalHubCardDeviceIntegrationDesc: '公开说明、Track1 工具与整合检核表。',
    leoPortalHubCardRuntimeDesc: 'Device Cloud 运行期／AAR 与 Track2 对照入口。',
    leoPortalHubCardSdkLabDesc: '集成测试环境，同时演练第一轨与第二轨行为。',
    leoPortalHubSdkFeaturedTag: '工程',
    leoPortalHubOpenNewTab: '点击以新标签页打开',
    leoPortalHubSdkCrossRefHint: '第一轨／第二轨对外说明请使用上方「装置端整合」两张卡片。',
    leoFloatDockTitle: 'Leo 对话（悬浮）',
    leoFloatDockMinimize: '最小化',
    leoFloatDockClose: '关闭',
    leoFloatDockResizeHint: '拖曳右下角调整窗口大小',
    leoFloatDockSwitchLabel: '悬浮 Leo 对话',
    leoFloatDockSwitchHint: '开启后可在各后台页面使用置顶对话框（可拖标题栏）；进入独立 Leo／Console／门户页时会自动隐藏以免重叠。',
    layoutThemeUseDark: '切换为深色主题',
    layoutThemeUseLight: '切换为浅色主题',
    leoProfileWorkbenchLeoMovedPrefix: 'C-Line · Leo：主权台、门户与 Leo 对话入口已移至侧栏「Leo 知识库」内之',
    leoProfileWorkbenchLeoMovedSuffix: '。',
    equipmentCategory: '设备类别',
    equipmentCategoryEdit: '设备类别-编辑',
    equipmentCategoryDel: '设备类别-删除',
    equipmentTypePermAdd: '设备类型-查询/新增（列表）',
    equipmentTypePermEdit: '设备类型-编辑',
    deviceSimulatorConsole: '模拟机控制台',
    leoDeviceOpsRolePolicy: '命令权限总表',
    leoDeviceOpsSemanticTraining: '语义训练工作台',
    leoTurnRoutingTrainingHub: 'T0 入口路由训练台',
    leoKnowledgePortalOpsInventory: 'Portal ops API 盘点台',
    leoKnowledgePortalOpsDailyHub: 'PORTAL_OPS 工作台',
    leoDeviceOpsReviewInbox: 'B 线审核待办',
    leoDeviceOpsDescriptionAutogen: 'Device_OPS 盤點台',
    leoDeviceOpsBLineDailyHub: 'B 线日常工作台',
    simulatorGroup: '模拟机',
    x600hGateway: 'X600H',
    xt90c2Simulator: 'XT90C2',
    blenderSimulator: 'Blender',
    maestroSimulator: 'Maestro模拟机',
    productCenter: "出品管理",
    productCenterFolderOther: '其他产品',
    dataCenter: "数据中心",
    maintenance: "运维管理",
    filesCenter:'文件管理',
    menuSetting:'菜单设置',
    organization:'用户组织',
    loginAccount:'账号列表',
    authorization:'角色管理',
    merchants:'商户列表',
    deviceList:'设备列表',
    deviceAutoServiceGroup: '售后维修保养',
    supportTicketGroup: '售后支持',
    supportTicketCreate: '提交工单',
    supportTicketMine: '我的工单',
    supportTicketWorkbench: '售后工作台',
    supportPlaybook: '标准问答库',
    deviceServiceWorkbench: '售后工单工作台',
    deviceServiceMyAssignments: '我的维修任务',
    deviceServiceAssignees: '维修负责人',
    deviceServiceMaintenance: '保养计划',
    deviceServiceFaultPolicy: '故障开单策略',
    deviceServiceEnterprisePolicy: '企业自动售后策略',
    deviceServiceMobile: '维修任务（手机）',
    deviceServiceBills: '维修账单',
    deviceServiceAnalytics: '故障分析',
    storeMaterialStock: '库存总览',
    storeMaterialOrders: '采购订单',
    storeMaterialConsumable: '耗材 BOM',
    storeMaterialMq: 'MQ 配置',
    storeMaterialInvoice: '发票',
    storeMaterialBarcodeAlias: '扫码映射',
    storeMaterialCount: '仓库盘点',
    storeMaterialBomWizard: 'BOM配置向导',
    storeMaterialAnalytics: '物料使用报告',
    storeMaterialPhysicalMerge: 'SKU合并建议',
    channelCategory:'通道类型',
    productCategory:'出品类型',
    optionCategory:'规格类型',
    optionList:'规格列表',
    storeAccount:'店铺账号',
    stores:'店铺管理',
    modelName:'设备名称/型号',
    category:'物料类型',
    configDistribute:'通道下发',
    devicesChannels:'设备通道',
    productsList5:'出品列表5',
    produceFivePos:'产品5门店客制',
    posCenter:'POS中心',
    menuDistribute:'菜单下发',
    storeMenu:'店铺菜单',
    merchantsData:'商家统计数据',
    devicsData:'设备统计数据',
    productionData:'设备出品数据',
    maintanenceData:'设备售后数据',
    devicesWorkingData:'设备使用数据',
    afterSalesReminder:'售后提示',
    maintenanceTips:'保养提示',
    fileUpgrade:'文件升级',
    dataDowloan:'数据下载',
    materialList:'物料列表',
    accessoriesCategory:'小吃类型',
    accessoriesList:'小吃列表',
    businessCenter: '业务中心',
    afterSalesServiceGroup: '售后服务',
    storeMaterialGroup: '库存管理',
    appsBanner:'App横幅展示',
    advertisement:'广告清单',
    advertBind:'广告绑定',
    advertDistribute:'广告下发',
    membersCenter:'会员列表',
    orderCenter:'订单列表',
    packBag:'打包袋子',
    appsCenter:'app管理',
    productsList2:'出品列表2',
    XTSeriesData:'配料机数据',
    productionData:'出品数据',
    materialDate:'物料数据',
    qualityData:'单杯数据',
    alertsLog:'故障日志',
    cleaningLog:'清洗记录',
    coffeeData:'咖啡机数据',
    coffeeMachineProductionData:'X600H 出品数据',
    coffeeMachineSingleCupData:'X600H 单杯数据',
    coffeeSumData:'品质数据',
    taxCenter:'税务中心',
    taxManagement:'税务管理',
    taxAllocation:'税务配置',
    dataOfTeaExtractorMachine:'萃茶机数据',
    teaMachineMaterial: '泡茶机物料',
    teaSingleCupParams: '单杯参数',
    dataOfBlendExtractorMachine:'冰沙机数据',
    dataOfMilkExtractorMachine:'奶沫机数据',
    beverageOutputData:'出品数据',
    singleCupData:'单杯数据',
    faultLog:'故障日志',
    deliveryPlatform:'外卖平台',
    uber:'Uber',
    otherProducts:'其他产品',
    listOfTeaExtractsProducts:'萃茶机产品',
    machineDebug:'设备调试',
    deviceRdGroup:'设备研发',
    presetCommand:'预设命令',
    commandConfiguration:'命令配置',
    memberHqGroup: '会员 HQ',
    memberHqDashboard: 'HQ 总览',
    memberHqFinance: '财务汇总',
    memberHqOps: '营运入口',
    distributorReportGroup: '渠道报表',
    distributorDashboard: '渠道总览',
    distributorMembers: '我的会员',
    distributorProfit: '分润明细',
    merchantTokenBillingPlatform: '账单平台',
    merchantDataBillingPlatform: '车载数据账单',
    linuxAutoOps: '车载运营',
    linuxAutoEquipment: '车载设备',
    linuxAutoRemoteOps: '远程运维',
    linuxAutoProfileConfig: 'Profile 配置',
    linuxAutoDataBilling: 'CAN 数据账单',
    linuxAutoModelRegistry: '型号注册',
    linuxAutoPartnerDelivery: '伙伴交付',
    linuxAutoFleetMonitor: '车队监控',
    linuxAutoDbcEntitlement: 'DBC 授权',
    linuxAutoCabinFeatures: '座舱功能',
    linuxAutoCanAutoMatch: 'CAN 自动匹配',
    operationAndMaintenanceServices:'运维服务',
    productionList:'出品清单',
    smallMaterial:'小料列表',
    takeoutProducts:'外卖产品',
    pointRule:'积分规则',
    couponManagement:" 优惠券管理",
    couponList:"  优惠券列表",
    additionalProducts:'额外产品',
    type:'产品类型',
    taxAllocation:'税务配置',
    produce:'产品列表',
    produceList4:'出品列表4',
    smoothieMakerProduct:'冰沙机出品',
    machineMenu:'设备菜单',
    systemLog:"系统日志",
    add:'新增',
    edit:'编辑',
    delete:'删除',
    search:'查询',
    reset:'重置',
    detail:'详情',
    batchImport:'批量导入',
    oneClickCopy:'一键复制',
    resetPwd:'重置密码',
    machineList:'设备列表',
    export:'导出',
    log:'日志',
    bindStore:'绑定店铺',
    bindMachine:'绑定设备',
    codeRule:'编码规则',
    batchDelete:'批量删除',
    region:'区域'



  },
  acoount: {
    name: '名称',
    enterpriseName: '企业名称',
    account: '账号',
    password: '密码',
    confirmPassword: '确认密码',
    roleTitle:'角色职称',
    roleName:'角色名称',
    searchKeyword:'账号/手机/邮箱/角色',
    phone:'手机号码',
    email:'邮箱',
    idNumber:'证件号',
    workAddress:'工作地址',
    status:'状态',
    onDuty:'在岗',
    leaveDuty:'离岗',
    takeVacationrm:'休假',
    disable:'禁用',
    profilePicture:'头像',
    confirmPasswordCannotBeEmpty:'确认密码不能为空',
    inconsistentPasswordInput:'密码输入不一致',
    emailFormatError:'邮箱格式错误',
    phoneNumberFormatError:'手机号格式错误',
    notes:'备注',
    empower:'授权',
    contactInformation:'联系方式',
    userOrganizationType:'用户组织类型',
    userOrganizationName:'用户组织名称',
    describe:'描述',
    available:'可用',
    deactivate:'停用',

  },
  merchant: {
    account: '登陆账号',
    password: '密码',
    store: '店铺',
    status:'状态',
    available:'正常',
    deactivate:'停用',
    merchantName:'商家名称',
    searchKeyword:'商家名称/负责人/电话/地址',
    cooperationType:'商户类型',
    selectCooperationTypeFirst:'请先选择商户类型',
    noUserOrganizationForType:'该类型下暂无用户组织，请先在「用户组织」中配置',
    enterpriseSegment:'经营场景',
    segmentDistributor:'渠道批发',
    segmentShop:'门店商用',
    segmentHome:'家用 Leo',
    businessLicense:'营业执照',
    frontIDCard:'身份证正面',
    backIDCard:'身份证反面',
    head:'负责人',
    Telephone:'联系电话',
    userOrganization:'用户组织',
    businessAddress:'注册地址',
    trade:'营业',
    closeBusiness:'歇业',
    superior:'上级',
    supervisorSubordinateRelation:'上下级关系',
    clickView:'点击查看',
    business:'商家',
    country:'国家',
    address:'地址',
    shopNames:'店铺名称',
    storeType:'门店类型',
    selfService:'自助',
    askFor:'自取',
    SelfPickupTakeoutShop:'自取+外卖店',
    selfServicePickUpTakeout:'自助+自取+外卖',
    businessHours:'营业时间',
    closingTime:'打烊时间',
    operatingCycle:'营业周期',
    Monday:'周一',
    Tuesday:'周二',
    Wednesday:'周三',
    Thursday:'周四',
    Friday:'周五',
    Saturday:'周六',
    Sunday:'周日',
    picture:'图片',
    vatNumber:'VAT增值税号',
    kvtCompanyRegistrationNumber:'KVK公司注册号码',
    invoiceUnifiedNumbering:'发票统编',
    invoiceAccountNumber:'发票账号', 
    POSAPIKey:'POS API Key',
    POSAccount:'POS Account',
    APPAPIKey:'APP API Key',
    APPAccount:'APP Account',
    APPClientKey:'APP Client Key',
    region:'区域'

  },
  device:{
    deviceType:'设备类型',
    totalDevice:'设备总数',
    passConfigName:"名称",
    offLineDevice:'离线设备',
    materialShortageDevice:'缺料设备',
    alertingDevice:'报警设备',
    lockDevice:'锁机设备',
    maintenanceDevice:'需要保养设备',
    businessInformation:'设备业务资料',
    deviceId:'设备ID',
    deviceModel:'型号',
    modelCodeKey:'型号代码',
    modelCodePlaceholder:'例：PT5 或 XRROSS_PT5，需全站唯一',
    modelCodeRequired:'请填写型号代码（对应 Leo model_key）',
    dealer:"零售商",
    deviceImie:'设备编码',
    equipmentSerialNumber:'设备序列号',
    posNumber:'刷卡机编码',
    store:'店铺',
    location:'设备位置',
    none:'暂无',
    log:"日志",
    fault:"故障",
    normal:"正常",
    offline:"离线",
    linkOffline:"模组离线",
    onLine:"在线",
    isFault:"是否故障",
    type:"类型",
    fullyAutomatic:"全自动",
    semiAutomatic:"半自动",
    availableMerchants:"可使用商家",
    faultStatistics:"故障统计",
    basicMaintenance:"基础保养",
    deepMaintenance:"深度保养",
    onLineDevice:'在线设备',
    equipmentOnlineStatus:"设备状态:",
    moduleLinkStatus:"模组连线:",
    hostProduceStatus:"主机可制作:",
    hostReadyCanProduce:"可制作",
    hostReadyNeedWake:"需唤醒",
    hostReadyUnknown:"未知",
    linkOnlineHostSleep:"在线·主机休眠",
    macFastRebindEnabled:"MAC快速重绑",
    macFastRebindPending:"重绑未就绪",
    brandName: "品牌名称:",
    telephone: "电话:",
    equipmentModelName: "设备型号/名称:",
    dateOfManufacture: "生产日期:",
    usageDate: "使用日期:",
    menu:"菜单",
    productName :"产品名",
    channelConfiguration :"通道配置",
    channelNumber :"通道号",
    material :"物料",
    shelfLife :"保鲜期",
    alarmListForTheDay: "报警列表(当天)",
    content :"内容",
    time :"时间",
    key: "按键",
    frequency :"次数",
    remoteOperation :"远程操作",
    menuStatus: "菜单状态",
    updated:  "已更新",
    notUpdated:  "未更新",
    success :"成功",
    lock: "锁机",
    unlock: "解锁",
    startup: "开机",
    shutdown: "关机",
    restart: "重启",
    param: "参数",
    factoryParam: '出厂参数',
    moduleParam: '模块参数',
    paramBaselineOpen: '设置参数',
    paramBaselineTitle: '设置参数（Leo 型号基准）',
    paramBaselineHint: '参数键请与设备配置 JSON path 一致（例：config.stirTime）；保存后供 Leo 与机器实际配置比对。',
    paramBaselineAddRow: '新增参数行',
    paramBaselineSave: '保存',
    paramBaselineRefresh: '重新加载',
    paramKey: '参数键',
    paramKeyPh: '例：config.stirTime',
    paramDisplayName: '显示名称',
    standardValue: '标准值',
    lowerLimit: '下限',
    upperLimit: '上限',
    unit: '单位',
    paramRemark: '备注',
    paramBaselineNoProfile: '该型号尚无可读取的 L1 配置文件（或无 PUBLISHED 版）。请先在「配置文件管理」建立／发布绑定该型号的 Profile。',
    paramBaselineProfileSource: '参数默认来源：{name} · published 版号 {version}',
    paramBaselineApplyPublished: '从最新 published 套用',
    paramBaselineApplyConfirm: '将按最新 published 的 JSON 合并至表格（同键将覆盖标准值与上下限，并新增不存在的键）。确定？',
    paramBaselineApplyDone: '已套用 published 建议值（请确认后保存）',
    paramBaselineTypeUnionTitle: '同设备类型 · 各型号 published 路径联集（参考）',
    paramBaselineTypeUnionMissing: '无 Profile 的型号 ID',


  },
  produce: {
    name: '名称',
    price: '价格',
    uberPrice: 'Uber单价',
    matterType: '物料类型',
    matterTypeKind: '类型性质',
    matterTypeKindPhysical: '实体物料',
    matterTypeKindParameter: '参数',
    matterTypeParameterHint: '「参数」类型不参与物料消耗统计，适用于程序、浓度档、水温等制作维度。',
    countsInConsumption: '计入消耗',
    normType: '规格类型',
    matter: '物料',
    min: '最小值',
    max:'最大值',
    shelfLife:'保鲜期',
    unit:'单位',
    hour:'小时',
    step1:'产品资料',
    step2:'产品物料',
    step3:'产品配方',
    step4:'配方组合',
    step5:'产品小料',
    produceName:'出品名称',
    produceCode:'出品编码',
    produceType:'出品类型',
    showSnacks:'显示小吃',
    yes:'是',
    no:'否',
    describe:'描述',
    order:'顺序',
    value:'值',
    unit:'单位',
    norm:'规格',
    select:'选择',
    step:'步骤',
    matterSequence:'物料顺序',
    action:'操作',
    freeSnacks:'免费小料',
    feeBasedMaterials:'收费小料',
    nextStep:'下一步',
    back:'上一步',
    save:'保存',
    saveUpdate:'保存更新',
    productList:'出品菜单',
    selectProduct:'选择出品',
    menuSort:'排序',
    produceImport:'出品导入',
    bind:'绑定',
    bindMachien:'绑定设备',
    smallMatterType:'小料类型',
    listing:'上架',
    isSales:'可下单',
    productListName:"输入出品菜单名称",
    Text1:'输入出品名称',
    Text2:'商家',
    Text3:'物料',
    Text4:'小料',
    Text5:'饮品',
    Text6:'小吃',
    Text7:'新增配方',
    Text8:'更新',
    Text9:'该产品编码已存在',
    Text10:'请完善产品信息',
    Text11:'茶品',
    Text12:'第一段',
    Text13:'第二段',
    Text14:'第三段',
    Text15:'出',
    Text16:'不出',
    Text17:'范围:',
    Text18:'茶叶量:',
    Text19:'仅可填数字', 
    Text20:'冰块量:',
    Text21:'搅拌时间不能大于同段萃茶/萃取时间（上限 {max}）',
    Text22:'萃茶/萃取时间不能小于当前搅拌时间（{min}）',
    Text23:'配方「{name}」搅拌时间超过萃茶/萃取时间（上限 {max}），请调整后再保存',
    codeRule:'编辑规则',
    prefix:'前缀',
    suffix:'后缀',
    review:'预览',
    codeRuleDescribe:'这个格式就是收银系统打印编码的格式',

  },
  business: {
    name: '名称',
    type: '类型',
    homepage: '主页',
    advertisingList: '广告清单',
    pictureOrVideo: '图片/视频',
    addProductAdvertisements:'新增产品广告',
    AddImagesOrvideos:'新增图片/视频',
    userName: '用户名',
    email: '邮箱',
    sex: '性别',
    birthday: '生日',
    phone: '手机号',
    walletBalance: '钱包余额',
    integral: '积分',
    orderNo: '订单号',
    pickupCode: '取餐码',
    store: '店铺',
    amount: '订单金额',
    payAmount: '实付金额',
    receiptsPrice: '实收金额',
    discount: '优惠',
    orderStatus: '订单状态',
    toBePaid: '待支付',
    paid: '已支付',
    processing: '处理中',
    completed: '已完成',
    orderCancellation: '订单取消',
    orderRejection: '订单拒绝',
    paymentMethod: '支付方式',
    wallet: '钱包',
    cash: '现金',
    pos: '刷卡机',
    thirdParty: '第三方',
    otherPay: '其他',
    produce: '产品',
    unitPrice: '单价',
    number: '数量',
    parameter: '参数',
    totalTaxAmount:'总税额',
    taxName:'税名',
    taxAmount:'税额',
    taxRate:'税率',
    orderType: '订单类型',
    pack: '打包',
    dineIn: '堂食',
   
  },
  file: {
    name: '名称',
    version: '版本',
    keyword: '标识',
    file:'文件',
    upload:'上传',
    remark: '备注',
    publishStatus: '发布状态',
    published: '对外最新',
    archived: '已归档',
    backupStatus: '服务器备份',
    backedUp: '已备份',
    notBackedUp: '未备份',
    otaStatus: 'OTA状态',
    otaLiveBacked: '对外最新·已备份',
    otaLiveNoBackup: '对外最新·未备份',
    otaArchivedBacked: '已归档·已备份',
    otaArchivedNoBackup: '已归档·未备份',
    otaLinkBroken: '链接失效',
    otaStatusTipTitle: '状态说明：',
    otaStatusTipLiveBacked: '绿＝正在对外发且服务器有备份，正常。',
    otaStatusTipLiveNoBackup: '橙＝正在对外发但未备份，请补备份或重传。',
    otaStatusTipArchivedBacked: '灰＝已不对外，但可回滚。',
    otaStatusTipArchivedNoBackup: '红＝已归档且无备份，基本不可回滚，建议重传。',
    otaStatusTipLinkBroken: '红「链接失效」＝下载地址空或云端 404/不通，请重新上传 APK。',
    recheckLinks: '重新检查链接',
    history: '历史',
    historyTitle: '版本历史',
    backupNow: '补备份',
    batchBackup: '批量补备份',
    batchArchive: '批量归档',
    batchBackupConfirm: '确认对勾选项执行补备份？',
    batchBackupDone: '批量补备份结束',
    selectFirst: '请先勾选要操作的 APP',
    copyLink: '链接',
    linkCopied: '下载链接已复制',
    linkCopyFailed: '复制失败，请手动复制',
    noDownloadLink: '此 APP 尚无下载链接',
    backupRemoteGone: '云端 APK 已不存在（404）。请重新上传 APK 后再备份。',
    archive: '归档',
    archiveConfirm: '归档后旧设备不再取此版（文件保留可回滚），确认',
    rollback: '回滚',
    rollbackConfirm: '确认回滚为此版本？当前对外最新将归档保留。',
    otaBackupHint: '保存后系统会把包拉到服务器制品仓备份；旧设备仍用原下载链接。',
    otaReuploadHint: '若补备份报 404：云端文件已删，请在此重新上传 APK 后再点确定。'
  },
  coupon: {
    Text1: '名称',
    Text2: '优惠金额',
    Text3: '消耗积分',
    Text4:'状态',
    Text5:'详情',
    Text6:'可用',
    Text7:'不可用',
    Text8:'有效天数'
   
  },
  pass: {
    name: '名称',
    pass: '通道',
    passNumber: '通道号',
    preDischargeTime: '预出料时间',
    addPass:'新增通道',
    bindPass:'通道绑定',
    passConfigName:'通道配置名称'
   
  },
  operation:{
    business_data:"业务数据看板",
    orderAmount:"订单金额",
    orderQuantity:"订单数量",
    actualAmountReceived:"实收金额",
    top_10_beverage_rankings:"饮品榜单Top10",
    sales_revenue:"销售额",
    order_quantity:"订单数量",
    payment_method:"付款方式",
    real_time_orders_on_the_hour:"整点实时订单",
  },
  dataCenter:{
    Text1:"内容",
    Text2:"数据",
    Text3:"销售量/杯",
    Text4:"销售额/元",
    Text5:"消耗物料/g",
    Text6:"月",
    Text7:"日",
    Text8:"时",
    Text9:"图表",
    Text10:"单杯消耗物料",
    Text11:"排名",
    Text12:"出品消耗物料",
    Text13:"设备消耗物料",
    Text14:"百分比",
    Text15:"排名",
    Text16:"销售量",
    Text17:"销售额",
    Text18:"时间/S",
    Text19:"出品销售量",
    Text20:"出品销售额",
    Text21:"设备销售量",
    Text22:"设备销售额",
    Text23:"总杯量",
    Text24:"总配方量/克",
    Text25:"实际总配方量/克",
    Text26:"坏杯量/杯",
    Text27:"坏杯率/%",
    Text28:"误差率/%",
    Text29:"出品名称",
    Text30:"制作方式",
    Text31:"扫码",
    Text32:"产品",
    Text33:"手动",
    Text34:"订单号",
    Text35:"门店",
    Text36:"单价",
    Text37:"配方总量",
    Text38:"实际出杯量",
    Text39:"出杯时间",
    Text40:"误差(%)",
    Text41:"坏杯",
    Text42:"正常",
    Text43:"制作完成",
    Text44:"制作失败",
    Text45:"完成时间",
    Text46:"模式",
    Text47:"通道",
    Text48:"状态",
    Text49:"未完成",
    Text50:"已完成",
    Text51:"出品名称",   
    Text52:"杯数", 
    Text53:"总价",  
    Text54:"订单统计",  
    Text55:"订单列表",  
    Text56:"订单金额",  
    Text57:"订单数量",  
    Text58:"实收金额",    
    Text59:"产品金额",   
    Text60:"茶叶量",   
    Text61:"出水量",  
    Text62:"销售量/桶",   
    Text63:"桶",    
    Text64:"偏酸/萃取过短",    
    Text65:" 均衡/萃取适中",    
    Text66:"偏苦/萃取过度",    
    Text67:"味苦/浓度低",    
    Text68:"适中",    
    Text69:"强/浓度高",  
    Text70:"萃取时间",    
    Text71:"水粉比",      
    strongBalance:"強平衡",
    weakBalance:"弱平衡",
    mediumAcid:"中酸",
    strongAcid:"強酸",
    goldenCup:"金杯",
    weakAcid:"弱酸",
    bitter:"苦",
    strongBitter:"強苦",
    weakBitter:"弱苦",  
    extractionTime:"萃取时间",   
    Text72:"动态校准",
  },
  taxation:{
    Text1:"税名",   
    Text2:"税率",   
    Text3:"基数", 
    Text4:"备注", 
    Text5:"国家", 
    Text6:"类型",  
    Text7:"堂食",  
    Text8:"打包",  
    Text9:"产品类型",
    Text10:"税种",
    Text11:"平台外卖",       
  },
  uber:{
    Text1:"uber店铺",   
    Text2:"平台店铺",   
    Text3:"菜单状态",
    Text4:"店铺状态",
     Text5:"已绑定",
     Text6:"未绑定",
     Text7:"同步"
    
  },

  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    readAndAgree:'已阅读并同意',
    pleaseCheckThePrivacyAgreement:'请勾选隐私协议',
    termTip:'<<隐私协议>>',
    Text1:'请输入账号',
    Text2:'请输入账号'


  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    github: '项目地址',
    screenfull: '全屏',
    theme: '换肤',
    size: '布局大小'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  common:{
    tower:'台',
    yuan:'元',
    cup:'杯',
    place:'位',
    individual:'个',
    language:'语言',
    success:'成功',
    fail:'失败',
    createTime:'创建时间',
    all:'全部',
    common:'全部',
    sureDel:'确定删除',
    tip:'提示',
    status:'状态',
    bing:'绑定',
    pleaseSelectDevice:'请选择设备',
    pleaseSelectMenu:'请选择菜单',
    pleaseSelectModel:'请选择型号',
    pleaseSelect:'请选择',
    code:'编码',
    entering_the_platform:'进入平台',
    date:"日期",
    address_fail:"地址不正确",
    back:'返回',
    pleaseEnter:'请输入',
    uploadImageBtn:'点击上传图片',
    uploadImageBtnTip:'仅支持上传JPG 格式和PNG格式（限制10M以内）',
    uploadVideoBtn:'点击上传视频',
    uploadVideoBtnTip:'仅支持上传mp4或者MP4文件（限制50M以内）',
    videoPlayTip:' 您的浏览器不支持视频播放',
    menuVersion:"菜单版本"
    
  },
  table:{
    search: '查询',
    detail:'详情',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    add:'新增',
    copy:'复制',
    produceCodeRule:'编码规则',
    batchDeletion:'批量删除',
    batchImport:'批量导入',
    batchCopy:'批量复制',
    export:'数据导出',
    import:'导入',
    templateDownload:'模板下载',
    dragAndDropUpload:'将文件拖到此处，或点击上传',
    picture:'图片',
    resetPwd:'重置密码',
    more:'更多'
  },
  coffeeData:{
    Text1:"浸泡流量",   
    Text2:"浸泡时间",   
    Text3:"萃取流量",   
    Text4:"萃取压力",   
    Text5:"萃取温度",   
    Text6:"订单类型",   
    Text7:"状态",   
    Text8:"出杯时间",  
    Text9:"粉量",   
    Text10:"设备编码",   
    Text11:"出品名称",   
    Text12:"咖啡液",   
    Text13:"压粉力度",   
    Text14:"粉饼厚度",   
    Text15:"萃取流速",   
    Text16:"萃取腔体位置",  
    Text17:"研磨度1",  
    Text18:"研磨度2",  
     
  }
}


// WEBPACK FOOTER //
// ./src/lang/zh.js